import { observer } from "mobx-react";
import ButtonBack from "newApp/components/ButtonBack";
import MainLayout from "newApp/components/layouts/MainLayout";
import StepsCreateError from "newApp/components/StepsCreateError";
import StepsForm from "newApp/components/StepsForm";
import Button from "newApp/kit/components/Button";
import ButtonsContainer from "newApp/kit/components/ButtonsContainer";
import FlexColumn from "newApp/kit/components/FlexColumn";
import H1 from "newApp/kit/components/H1";
import { URL_ADMINISTRATION_STEPS } from "newApp/routing/urls";
import { StepsEditPageStore } from "newApp/stores/pages/administrations/steps/StepsEditPageStore";
import React, { useEffect } from "react";
import { useHistory, useParams } from "react-router";

const store = new StepsEditPageStore();

const StepsEditPage: React.FC = () => {
  const { push } = useHistory();
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    store.init(id);
    return () => store.reset();
  }, [id]);

  const onClickCreate = async () => {
    const result = await store.onSave();
    if (result) {
      push(URL_ADMINISTRATION_STEPS);
    } else {
      window.scrollTo({ behavior: "smooth", top: 0 });
    }
  };

  const goOnList = () => push(URL_ADMINISTRATION_STEPS);

  return (
    <MainLayout isLoading={store.isLoadings.getSteps}>
      <H1>Редактирование конструктора шагов</H1>
      <FlexColumn>
        <ButtonBack url={URL_ADMINISTRATION_STEPS}>Назад к списку</ButtonBack>
        <StepsCreateError error={store.error} onCloseClick={store.resetError} />
        <StepsForm {...store.stepsForm} />
        <ButtonsContainer>
          <Button onClick={onClickCreate} disabled={store.isLoadings.saveSteps}>
            Сохранить изменения
          </Button>
          <Button onClick={goOnList} variant="secondary">
            Отменить
          </Button>
        </ButtonsContainer>
      </FlexColumn>
    </MainLayout>
  );
};

export default observer(StepsEditPage);
